import {Inject, Injectable, PLATFORM_ID} from "@angular/core";
import {Resolve} from "@angular/router";
import {TokenDataProviderService} from "./token-data-provider.service";
import {isPlatformServer} from "@angular/common";

@Injectable({ providedIn: 'root' })
export class AuthStateResolver implements Resolve<boolean> {
  constructor(
    private ts: TokenDataProviderService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  resolve(): boolean {
    if (isPlatformServer(this.platformId)) {
      console.log('isAuthentictedSSR')
      return this.ts.isLoggedInSSR();
    }
    console.log('isAuthenticated');

    return !this.ts.hasAnonymousSsrSession && this.ts.isLoggedIn();
  }
}
